import { Fragment, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import { IoMdAddCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useSessionStorage } from "react-use";
import useSharedData from "../../../../../hooks/useSharedData";
import ShipmentForm from "../../../../shop/components/Shipments/components/ShipmentForm";
import detectDiryFields from "../../../../shop/components/Shipments/functions/detectDiryFields";
import generateRandomString from "../../../../shop/components/Shipments/functions/generateRandomString";
import avaBoxAdd from "../functions/avaBoxAdd";
import avaBoxSubmit from "../functions/avaBoxSubmit";
import DetailForm from "./DetailForm";
import ModalPrint from "./ModalPrint";
import style from "./ShipmentSection.module.css";

function ShipmentSectionAvaBox({
  lastPartNumber = 100,
  company,
  senderAddress,
}) {
  const navigate = useNavigate();

  const baseInfoShipment = {
    packaging: 0,
    cost: 10000000,
    isFragile: false,
    isLiquid: false,
    ui: generateRandomString(),
    serviceInPlace: 0,
    needPackaging: false,
  };

  const [shipments, setShipments] = useSessionStorage("shipmentsAvaBox", [
    baseInfoShipment,
  ]);

  const { isAgent } = useSharedData();

  const [prices, setPrices] = useState([]);
  const [loading, setLoading] = useState(false);

  const [needPrint, setNeedPrint] = useState(isAgent);
  const [needSMS, setNeedSMS] = useState(false);

  const [modalPrint, setModalPrint] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, dirtyFields },
    control,
    getValues,
    watch,
    reset,
    setValue,
    unregister,
  } = useForm();

  const { fields, remove, insert, append } = useFieldArray({
    name: "items",
    control,
  });

  useEffect(() => {
    shipments.forEach(item => append(item, { shouldFocus: false }));
  }, []);

  const isRate = () => {
    if (prices.length === 0) return true;

    if (fields.length !== prices.length) return true;

    for (const item of prices) {
      if (item.price === 0) return true;
    }

    return false;
  };

  useEffect(() => {
    setPrices([]);
  }, [company, senderAddress]);

  return (
    <Fragment>
      <section className="pt-3">
        <p className="title-style">مشخصات مرسوله</p>
        <button
          className={"buttonUi rounded-1 f-center " + style.addBtn}
          onClick={() => append(baseInfoShipment)}
        >
          <span className="ms-3">افزودن</span>
          <span className="fs-4">
            <IoMdAddCircle />
          </span>
        </button>

        <form
          onSubmit={handleSubmit(values => {
            setShipments(values.items);
            reset(values);
            if (isRate()) {
              setModalPrint(true);
            } else {
              avaBoxAdd({
                shipments,
                setLoading,
                needPrint,
                needSMS,
                navigate,
              });
            }
          })}
        >
          {fields.map((item, idx) => (
            <ShipmentForm
              key={item.ui}
              index={idx}
              register={register}
              shipment={item}
              errors={errors?.items ? errors?.items[idx] : {}}
              remove={remove}
              getValues={getValues}
              insert={insert}
              lastPartNumber={lastPartNumber}
              watch={watch}
              control={control}
              setValue={setValue}
              isDirty={detectDiryFields(dirtyFields, idx)}
              unregister={unregister}
              priceState={{ prices, setPrices }}
              type={2}
            />
          ))}

          <DetailForm shipments={watch("items")} prices={prices} />

          <div className="mt-3">
            {loading === true && (
              <button
                type="button"
                className="buttonUi btn-orange-header-button"
              >
                <div className="d-flex align-items-center px-4">
                  <Spinner
                    style={{
                      width: "20px",
                      height: "20px",
                      fontSize: "0.8rem",
                    }}
                  />
                  <span className="me-3"> در حال استعلام</span>
                </div>
              </button>
            )}

            {fields.length !== 0 && (
              <Fragment>
                {loading === false && (
                  <button
                    type="submit"
                    className={
                      "buttonUi text-center " +
                      (isRate() === true
                        ? "btn-orange-header-button"
                        : "btn-success-style")
                    }
                  >
                    {isRate() === true ? (
                      <span>استعلام قیمت</span>
                    ) : (
                      <span>ثبت نهایی سفارش</span>
                    )}
                  </button>
                )}
              </Fragment>
            )}
          </div>
        </form>
      </section>
      {modalPrint === true && (
        <ModalPrint
          close={() => setModalPrint(false)}
          print={{ needPrint, setNeedPrint }}
          sms={{ needSMS, setNeedSMS }}
          set={() =>
            avaBoxSubmit({
              shipments,
              setPrices,
              setLoading,
              needPrint,
              needSMS,
            })
          }
        />
      )}
    </Fragment>
  );
}

export default ShipmentSectionAvaBox;
